import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';

export class IngredientDTO extends BaseDTO {
  ingredientId: number;
  name: string;
  pubchemName: string; // TODO: refractor into NameValueDTO
  pharmacologicalClassification: string;
  fdaPharmacology: string;
  source: string;
  mesh: string;

  atcCodes: NameValueDTO[];
}
